import React from 'react';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { Pathname } from '@components/main-components/link/AccessibleLink';

export const Heading = ({ header, pathnameUri }: { header: string; pathnameUri?: Pathname }) => {
  const heading = (
    <div className="block items-center whitespace-nowrap ">
      <h1 className="font-title text-title-l font-medium md:text-title-xl">{header}</h1>
    </div>
  );

  if (!pathnameUri) return heading;

  return <AccessibleLink pathnameUri={pathnameUri}>{heading}</AccessibleLink>;
};
